// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app__modules_study_study_module_ts":"5994afe84e76252e","src_app__modules_dashboard_dashboard_module_ts":"0ae739cf4dbf0294","node_modules_dompurify_dist_purify_es_mjs":"b9ca94c0b451fb49","node_modules_canvg_lib_index_es_js":"6ba2d6c7da82fe50"}[chunkId] + ".js";
};